import React, { useEffect, useState, useRef } from 'react';

export function AuthLoading() {
  return (
    <div style={{ position: 'fixed', inset: 0, background: '#07070a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#d4d4d4', fontSize: '13px', letterSpacing: '0.18em', textTransform: 'uppercase', fontFamily: 'Georgia, serif', opacity: 0.4 }}>shift</div>
    </div>
  );
}

export function NoSession({ supabase }) {
  const [mounted, setMounted] = React.useState(false);
  const [emailInput, setEmailInput] = React.useState('');
  const [magicLinkSent, setMagicLinkSent] = React.useState(false);
  const [magicLinkLoading, setMagicLinkLoading] = React.useState(false);
  const [showEmailForm, setShowEmailForm] = React.useState(false);
  React.useEffect(() => { setMounted(true); }, []);

  async function handleMagicLink(e) {
    e.preventDefault();
    if (!emailInput.trim()) return;
    setMagicLinkLoading(true);
    const { error } = await supabase.auth.signInWithOtp({
      email: emailInput.trim(),
      options: {
        emailRedirectTo: typeof window !== 'undefined' ? window.location.origin : 'https://shiftirl.ai',
      },
    });
    setMagicLinkLoading(false);
    if (!error) setMagicLinkSent(true);
  }

  async function handleGoogleSignIn() {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: typeof window !== 'undefined' ? window.location.origin : '' },
    });
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: '#07070a',
      display: 'flex', flexDirection: 'column',
      fontFamily: 'Georgia, serif', overflow: 'hidden',
    }}>

      {/* Nav */}
      <div style={{ padding: '18px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '0.5px solid #1e1e2a', flexShrink: 0 }}>
        <span style={{ color: '#c8a96e', fontSize: 15, fontWeight: 'bold', letterSpacing: '0.12em' }}>SHIFT</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <span style={{ color: '#444', fontSize: 12 }}>About</span>
          <span style={{ color: '#444', fontSize: 12 }}>Pricing</span>
        </div>
      </div>

      {/* Hero */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 32px' }}>

        {/* Animated portrait */}
        <div style={{ position: 'relative', width: 180, height: 180, marginBottom: 36, flexShrink: 0 }}>
          <style>{`
            @keyframes sp1 { 0%,100%{opacity:.12;transform:scale(1)} 50%{opacity:.3;transform:scale(1.03)} }
            @keyframes sp2 { 0%,100%{opacity:.18;transform:scale(1)} 50%{opacity:.38;transform:scale(1.04)} }
            @keyframes sp3 { 0%,100%{opacity:.25;transform:scale(1)} 50%{opacity:.45;transform:scale(1.05)} }
            @keyframes sp4 { 0%,100%{opacity:.35;transform:scale(1)} 50%{opacity:.6;transform:scale(1.06)} }
            @keyframes sp5 { 0%,100%{opacity:.5;transform:scale(1)} 50%{opacity:.75;transform:scale(1.08)} }
            @keyframes sorb1 { 0%{transform:rotate(0deg) translateX(82px)} 100%{transform:rotate(360deg) translateX(82px)} }
            @keyframes sorb2 { 0%{transform:rotate(120deg) translateX(66px)} 100%{transform:rotate(480deg) translateX(66px)} }
            @keyframes sorb3 { 0%{transform:rotate(240deg) translateX(50px)} 100%{transform:rotate(600deg) translateX(50px)} }
            @keyframes sglow { 0%,100%{opacity:.35} 50%{opacity:.7} }
            @keyframes sfade { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
            .sr1{animation:sp1 4s ease-in-out infinite;transform-origin:center}
            .sr2{animation:sp2 4s ease-in-out infinite .5s;transform-origin:center}
            .sr3{animation:sp3 4s ease-in-out infinite 1s;transform-origin:center}
            .sr4{animation:sp4 4s ease-in-out infinite 1.5s;transform-origin:center}
            .sr5{animation:sp5 4s ease-in-out infinite 2s;transform-origin:center}
            .so1{animation:sorb1 14s linear infinite;transform-origin:90px 90px}
            .so2{animation:sorb2 10s linear infinite;transform-origin:90px 90px}
            .so3{animation:sorb3 18s linear infinite reverse;transform-origin:90px 90px}
            .scg{animation:sglow 3s ease-in-out infinite}
            .sf1{animation:sfade .8s ease both .3s;opacity:0}
            .sf2{animation:sfade .8s ease both .6s;opacity:0}
            .sf3{animation:sfade .8s ease both .9s;opacity:0}
            .sf4{animation:sfade .8s ease both 1.2s;opacity:0}
            .sf5{animation:sfade .8s ease both 1.5s;opacity:0}
          `}</style>
          <svg width="180" height="180" viewBox="0 0 180 180" style={{ position: 'absolute', inset: 0 }}>
            <circle cx="90" cy="90" r="88" fill="none" stroke="#c8a96e" strokeWidth="0.5" className="sr1"/>
            <circle cx="90" cy="90" r="74" fill="none" stroke="#c8a96e" strokeWidth="0.5" className="sr2"/>
            <circle cx="90" cy="90" r="60" fill="none" stroke="#c8a96e" strokeWidth="0.8" className="sr3"/>
            <circle cx="90" cy="90" r="46" fill="none" stroke="#c8a96e" strokeWidth="1" className="sr4"/>
            <circle cx="90" cy="90" r="32" fill="rgba(200,169,110,0.06)" stroke="#c8a96e" strokeWidth="1.2" className="sr5"/>
            <circle cx="90" cy="90" r="18" fill="rgba(200,169,110,0.08)" className="scg"/>
            <g className="so1"><circle cx="90" cy="8" r="3" fill="#c8a96e" opacity="0.9"/></g>
            <g className="so2"><circle cx="90" cy="24" r="2" fill="#7a9e82" opacity="0.8"/></g>
            <g className="so3"><circle cx="90" cy="40" r="2" fill="#9b8fc4" opacity="0.7"/></g>
            <g className="scg">
              <path d="M82 84 a8 8 0 1 1 16 0" fill="none" stroke="#c8a96e" strokeWidth="1.2"/>
              <path d="M74 100 c0-6 3.6-10 8-10 a6 6 0 0 1 6 0 6 6 0 0 1 6 0 c4.4 0 8 4 8 10" fill="none" stroke="#c8a96e" strokeWidth="1.2" strokeLinecap="round"/>
            </g>
          </svg>
        </div>

        {/* Copy */}
        <div className="sf1" style={{ color: '#333', fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: 14, textAlign: 'center' }}>AI companion</div>

        <div className="sf2" style={{ textAlign: 'center', marginBottom: 12 }}>
          <div style={{ color: '#666', fontSize: 30, lineHeight: 1.4, fontWeight: 'normal' }}>Every signal.</div>
          <div style={{ color: '#888', fontSize: 30, lineHeight: 1.4, fontWeight: 'normal' }}>Every pattern.</div>
          <div style={{ color: '#c8a96e', fontSize: 30, lineHeight: 1.4, fontWeight: 'normal' }}>Every version of you.</div>
        </div>

        <div className="sf3" style={{ textAlign: 'center', maxWidth: 460, marginBottom: 32 }}>
          <div style={{ color: '#444', fontSize: 13, lineHeight: 1.8, fontStyle: 'italic' }}>
            Shift reads the signals you don't notice. Surfaces the patterns you can't see.<br/>
            Builds a living portrait that grows with you.
          </div>
        </div>

        {/* CTA */}
        <div className="sf4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
          <div
            onClick={handleGoogleSignIn}
            style={{
              border: '1px solid #7a9e8244', borderRadius: 8,
              padding: '11px 28px', color: '#7a9e82',
              fontSize: 13, cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 8,
              background: 'none',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#7a9e8288'; e.currentTarget.style.background = 'rgba(122,158,130,0.04)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#7a9e8244'; e.currentTarget.style.background = 'none'; }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#7a9e82" opacity=".7"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#7a9e82" opacity=".5"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#7a9e82" opacity=".4"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#7a9e82" opacity=".6"/>
            </svg>
            Continue with Google
          </div>
        </div>

        <div className="sf5" style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '16px 0', width: '100%', maxWidth: 320 }}>
          <div style={{ flex: 1, height: '0.5px', background: '#1e1e2a' }} />
          <span style={{ color: '#2a2a2a', fontSize: 11, fontStyle: 'italic' }}>or</span>
          <div style={{ flex: 1, height: '0.5px', background: '#1e1e2a' }} />
        </div>

        {!magicLinkSent ? (
          <div className="sf5" style={{ width: '100%', maxWidth: 320, display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center' }}>
            {!showEmailForm ? (
              <div
                onClick={() => setShowEmailForm(true)}
                style={{ color: '#444', fontSize: 12, cursor: 'pointer', fontStyle: 'italic', fontFamily: 'Georgia, serif' }}
                onMouseEnter={e => e.currentTarget.style.color = '#888'}
                onMouseLeave={e => e.currentTarget.style.color = '#444'}
              >
                Sign in with email instead
              </div>
            ) : (
              <>
                <input
                  type="email"
                  value={emailInput}
                  onChange={e => setEmailInput(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleMagicLink(e)}
                  placeholder="your@email.com"
                  style={{
                    width: '100%', background: '#111', border: '1px solid #272736',
                    borderRadius: 8, color: '#888', fontFamily: 'Georgia, serif',
                    fontSize: 13, padding: '10px 14px', outline: 'none', textAlign: 'center',
                  }}
                  autoFocus
                />
                <div
                  onClick={handleMagicLink}
                  style={{
                    width: '100%', border: '1px solid #7a9e8244', borderRadius: 8,
                    padding: '10px 20px', color: magicLinkLoading ? '#444' : '#7a9e82',
                    fontSize: 13, cursor: magicLinkLoading ? 'default' : 'pointer',
                    textAlign: 'center', fontFamily: 'Georgia, serif',
                    background: 'none',
                  }}
                >
                  {magicLinkLoading ? 'Sending...' : 'Send sign-in link'}
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="sf5" style={{ textAlign: 'center', maxWidth: 320 }}>
            <div style={{ color: '#7a9e82', fontSize: 13, marginBottom: 6, fontFamily: 'Georgia, serif' }}>
              Check your inbox
            </div>
            <div style={{ color: '#444', fontSize: 12, fontStyle: 'italic', lineHeight: 1.7, fontFamily: 'Georgia, serif' }}>
              We sent a sign-in link to {emailInput}.<br/>It expires in 1 hour.
            </div>
          </div>
        )}

        <div className="sf5" style={{ color: '#2a2a2a', fontSize: 11, fontStyle: 'italic', textAlign: 'center', marginTop: 12 }}>
          Your portrait belongs to you. We never sell your data.
        </div>

      </div>

      {/* Footer */}
      <div style={{ padding: '14px 32px', borderTop: '0.5px solid #1e1e2a', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 32, flexShrink: 0 }}>
        {['No ads', 'End-to-end encrypted', 'Export or delete anytime'].map((t, i) => (
          <React.Fragment key={t}>
            {i > 0 && <span style={{ color: '#272736' }}>·</span>}
            <span style={{ color: '#2a2a2a', fontSize: 11 }}>{t}</span>
          </React.Fragment>
        ))}
      </div>

    </div>
  );
}

export function NamingScreen() { return null; }

export function UsernameScreen() { return null; }

export function SetupScreen({ onSetup, supabase }) {
  const [username, setUsername] = useState('');
  const [aiName, setAiName] = useState('');
  const [usernameStatus, setUsernameStatus] = useState('idle');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const checkTimeout = useRef(null);

  const isValid = usernameStatus === 'available' && aiName.trim().length > 0;

  function handleUsernameChange(val) {
    setUsername(val);
    clearTimeout(checkTimeout.current);
    setUsernameStatus('idle');
    if (!val) { setUsernameStatus('idle'); return; }
    const valid = /^[a-zA-Z0-9_]{3,20}$/.test(val);
    if (!valid) { setUsernameStatus('invalid'); return; }
    setUsernameStatus('checking');
    checkTimeout.current = setTimeout(async () => {
      const { data } = await supabase.from('users').select('id').eq('username', val).maybeSingle();
      setUsernameStatus(data ? 'taken' : 'available');
    }, 500);
  }

  async function handleSubmit() {
    if (!isValid || saving) return;
    setSaving(true);
    setError('');
    const result = await onSetup({ username: username.trim(), aiName: aiName.trim() });
    if (result?.error) { setError(result.error); setSaving(false); }
  }

  const hintText = { idle: 'Letters, numbers, underscores · 3–20 characters', checking: 'Checking availability...', available: 'Available', taken: 'Already taken — try another', invalid: username.length < 3 ? 'At least 3 characters' : 'Letters, numbers, and underscores only' }[usernameStatus];
  const hintColor = { idle: '#333', checking: '#555', available: '#7a9e82', taken: '#c46050', invalid: '#c46050' }[usernameStatus];

  return (
    <div style={{ fontFamily: 'Georgia, serif', background: '#07070a', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 32px' }}>
        <div style={{ fontSize: 13, letterSpacing: '0.2em', color: '#c8a96e', fontWeight: 'normal' }}>SHIFT</div>
        <div style={{ display: 'flex', gap: 24 }}>
          {['About','Pricing'].map(l => (<span key={l} style={{ fontSize: 13, color: '#555', cursor: 'pointer' }}>{l}</span>))}
        </div>
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' }}>
        <div style={{ position: 'relative', width: 160, height: 160, marginBottom: 32, flexShrink: 0 }}>
          {[{ size: 160, opacity: 0.12 }, { size: 120, opacity: 0.18 }, { size: 84, opacity: 0.28 }].map(({ size, opacity }, i) => (
            <div key={i} style={{ position: 'absolute', width: size, height: size, top: (160 - size) / 2, left: (160 - size) / 2, borderRadius: '50%', border: `0.5px solid rgba(200,169,110,${opacity})` }} />
          ))}
          <div style={{ position: 'absolute', width: 56, height: 56, top: 52, left: 52, borderRadius: '50%', border: '1px solid rgba(200,169,110,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(200,169,110,0.6)" strokeWidth="1"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
          </div>
        </div>
        <div style={{ fontSize: 11, letterSpacing: '0.15em', color: '#555', textTransform: 'uppercase', marginBottom: 16 }}>One last thing</div>
        <div style={{ fontSize: 28, color: '#888', textAlign: 'center', fontWeight: 'normal', lineHeight: 1.5, marginBottom: 6 }}>
          Before we begin —<br /><span style={{ color: '#c8a96e' }}>two things.</span>
        </div>
        <div style={{ fontSize: 14, color: '#444', textAlign: 'center', fontStyle: 'italic', lineHeight: 1.7, marginBottom: 48, maxWidth: 380 }}>
          This takes 30 seconds.<br />You won't be asked again.
        </div>
        <div style={{ width: '100%', maxWidth: 360 }}>
          <div style={{ marginBottom: 28 }}>
            <div style={{ fontSize: 11, color: '#555', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 }}>Your username</div>
            <input type="text" value={username} onChange={e => handleUsernameChange(e.target.value)} placeholder="how you appear in Shift" autoComplete="off" spellCheck="false" style={{ width: '100%', background: 'transparent', border: 'none', borderBottom: '1px solid #2a2a2a', color: '#e0e0e0', fontSize: 15, fontFamily: 'Georgia, serif', padding: '8px 0', outline: 'none' }} />
            <div style={{ fontSize: 11, marginTop: 7, minHeight: 16, fontStyle: 'italic', color: hintColor, transition: 'color 0.2s' }}>{hintText}</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, margin: '4px 0 28px' }}>
            <div style={{ flex: 1, height: 0.5, background: '#1e1e2a' }} />
            <div style={{ fontSize: 11, color: '#2a2a2a', letterSpacing: '0.08em' }}>and</div>
            <div style={{ flex: 1, height: 0.5, background: '#1e1e2a' }} />
          </div>
          <div style={{ marginBottom: 8 }}>
            <div style={{ fontSize: 11, color: '#555', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 }}>Name your AI</div>
            <input type="text" value={aiName} onChange={e => setAiName(e.target.value)} onKeyDown={e => e.key === 'Enter' && isValid && handleSubmit()} placeholder="what would you like to call me?" autoComplete="off" style={{ width: '100%', background: 'transparent', border: 'none', borderBottom: '1px solid #2a2a2a', color: '#e0e0e0', fontSize: 15, fontFamily: 'Georgia, serif', padding: '8px 0', outline: 'none' }} />
          </div>
          <div style={{ fontSize: 12, color: '#3a3a3a', fontStyle: 'italic', marginBottom: 28, lineHeight: 1.7 }}>
            Your personal companion. Call it anything — Shift, Atlas, or something entirely yours. You can rename it anytime.
          </div>
          <button onClick={handleSubmit} disabled={!isValid || saving} style={{ width: '100%', background: 'transparent', border: `1px solid ${isValid && !saving ? 'rgba(122,158,130,0.6)' : '#272736'}`, color: isValid && !saving ? '#7a9e82' : '#2a2a2a', fontSize: 12, fontFamily: 'Georgia, serif', letterSpacing: '0.15em', padding: 14, cursor: isValid && !saving ? 'pointer' : 'default', transition: 'all 0.2s', marginTop: 8 }}>
            {saving ? 'setting up your workspace...' : 'continue'}
          </button>
          {error && <div style={{ fontSize: 12, color: '#c46050', textAlign: 'center', marginTop: 14, fontStyle: 'italic' }}>{error}</div>}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 40, padding: 24 }}>
        {['No ads','End-to-end encrypted','Export or delete anytime'].map(t => (
          <div key={t} style={{ fontSize: 11, color: '#2a2a2a', letterSpacing: '0.06em' }}>{t}</div>
        ))}
      </div>
    </div>
  );
}


export function DisclaimerScreen({ userRecord, acceptDisclaimer, styles }) {
  return (
    <div style={styles.page}>
      <div style={styles.wordmark}>shift</div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '28px', maxWidth: '420px', width: '100%', padding: '0 24px' }}>
        <div style={{ color: '#555', fontSize: '13px', lineHeight: '2', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ color: '#777', fontSize: '14px', letterSpacing: '0.04em' }}>Before we begin, a few honest things.</div>
          <div style={{ color: '#444', fontSize: '13px', lineHeight: '1.9' }}>
            {userRecord?.ai_name || 'Shift'} is an AI companion. Not a therapist. Not a counselor. Not a substitute for professional mental health support. What's offered here is genuine — a space built for real thinking, depth conversation, and growth work that compounds over time.
          </div>
          <div style={{ color: '#444', fontSize: '13px', lineHeight: '1.9' }}>
            If you're carrying something that requires clinical support — a therapist, a psychiatrist, a doctor — {userRecord?.ai_name || 'Shift'} is not the right resource for that, and will tell you so when it matters.
          </div>
          <div style={{ color: '#444', fontSize: '13px', lineHeight: '1.9' }}>
            If you are ever in a moment of crisis — feeling unsafe, thinking about harming yourself, or in psychological emergency — please reach out to the{' '}
            <span style={{ color: '#666' }}>988 Suicide and Crisis Lifeline</span> by calling or texting{' '}
            <span style={{ color: '#666' }}>988</span>. They are available anytime. {userRecord?.ai_name || 'Shift'} will also guide you toward support if those signals appear during a session.
          </div>
          <div style={{ color: '#333', fontSize: '12px', lineHeight: '1.8' }}>
            With those honest things said — {userRecord?.ai_name || 'Shift'} is here, fully present, and ready to begin.
          </div>
        </div>
        <button onClick={acceptDisclaimer} style={{ background: 'none', border: '1px solid #222', borderRadius: '4px', color: '#888', fontSize: '13px', padding: '10px 28px', cursor: 'pointer', fontFamily: 'Georgia, serif', letterSpacing: '0.05em' }}>
          I understand. Let's begin.
        </button>
      </div>
    </div>
  );
}

export function MountGuard() {
  return <div style={{ background: '#07070a', position: 'fixed', inset: 0 }} />;
}
